import React from "react";
import { Box, Typography } from "@bca/ui-library";
import { formatSaleDate } from "../formatSaleDate";
import { InvoiceBreakdown, Vehicle } from "../Interfaces/vehicle.type";

interface InvoiceDescriptionProps {
  invoiceData: InvoiceBreakdown;
  vehicleData: Vehicle;
}

const InvoiceDescription: React.FunctionComponent<InvoiceDescriptionProps> = ({
  invoiceData,
  vehicleData,
}) => {
  return (
    <Box
      width="100%"
      flexDirection={{
        mobile: "column",
        desktop: "row",
      }}
      display="flex"
      justifyContent={{
        mobile: "flex-start",
        desktop: "justify-content",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        paddingBottom={{
          mobile: "16px",
          desktop: "32px",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          paddingRight="12px"
          minWidth="90px"
        >
          <Typography margin="0px" marginBottom="8px" variant="body-small">
            Invoice no.
          </Typography>
          <Typography
            margin="0px"
            variant="body-small"
            fontWeight="bold"
            color="footer-blue"
          >
            {invoiceData.invoiceNumber}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" paddingRight="12px">
          <Typography margin="0px" marginBottom="8px" variant="body-small">
            Issue date
          </Typography>
          <Typography
            margin="0px"
            variant="body-small"
            fontWeight="bold"
            color="footer-blue"
          >
            {formatSaleDate(invoiceData.invoiceDate)}
          </Typography>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        paddingBottom={{
          mobile: "16px",
          desktop: "32px",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          paddingRight="12px"
          minWidth="90px"
        >
          <Typography margin="0px" marginBottom="8px" variant="body-small">
            Sale Date
          </Typography>
          <Typography
            margin="0px"
            variant="body-small"
            fontWeight="bold"
            color="footer-blue"
          >
            {formatSaleDate(vehicleData.saleDate)}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" paddingRight="12px">
          <Typography margin="0px" marginBottom="8px" variant="body-small">
            Vehicle Registration Number
          </Typography>
          <Typography
            margin="0px"
            variant="body-small"
            fontWeight="bold"
            color="footer-blue"
          >
            {vehicleData.vrm}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InvoiceDescription;
